import FormField from '@adsk/alloy-react-form-field';
import Textarea from '@adsk/alloy-react-textarea';
import Modal from '@adsk/alloy-react-modal';
import styled from 'styled-components';

export const StyledModal = styled(Modal)`
  max-width: 600px;
  width: 100%;
  max-height: 90vh;
  height: auto;
`;

export const StyledModalBody = styled(Modal.Body)`
  max-height: 52vh;
  padding-bottom: 40px;
`;

export const StyledFormField = styled(FormField)`
  padding-top: 20px;
  width: 100%;
`;

export const StyledFormFieldHalf = styled(FormField)`
  padding-top: 20px;
  width: ${(props) => props.styleWidth}%;
  margin-left: ${(props) => props.marginLeft}px;
  display: inline-block;
`;

export const StyledDescription = styled(Textarea)`
  width: 100%;
`;

export const companyNameStyle = {
  'display': 'block',
  '& > li': {
    '& > div[title]': {
      display: 'none',
    },
  },
};
